import { lazy } from 'react'

export const ReachGoals = lazy(() => import('./ReachGoals'))
